import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitEnquiry(payload) {
  const { data } = await api.post("/enquiries", payload);
  return data;
}

export async function uploadResume(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload-resume", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
